import React, { forwardRef, useImperativeHandle, useState } from "react";

const ModalConfirm = (
  {
    approveFunc,
    content,
    rejectFunc,
    title,
    approveButtonName,
    rejectButtonName,
  },
  ref
) => {
  const [isActive, setIsActive] = useState(false);
  const [fadeClassName, setFadeClassName] = useState("modal-view-fade-in");
  const [scrollPos, setScrollPos] = useState(0);

  useImperativeHandle(ref, () => ({
    openModal: () => {
      setIsActive(true);
      setFadeClassName("modal-view-fade-in");
      setScrollPos(window.pageYOffset);
    },
  }));

  const closeModal = () => {
    $(window).scrollTop(scrollPos);
    setFadeClassName("modal-view-fade-out");
    setIsActive(false);
  };

  const handleApproveButton = () => {
    approveFunc();
    closeModal();
  };

  const handleRejectButton = () => {
    if (rejectFunc != undefined) {
      rejectFunc();
    }
    closeModal();
  };

  if (!isActive) {
    return null;
  }

  let header = "";
  if (title) {
    header = (
      <div className="modal-view-header">
        <p style={{ margin: "0 0 6px", paddingTop: "1.5em" }}>
          <strong>{title}</strong>
        </p>
      </div>
    );
  }
  return (
    <div className="modal-view">
      <div className={fadeClassName}>
        <div className="modal-view-overAll">
          <div className="modal-view-overlay" />
          <div className="modal-view-dialog">
            <div className="modal-view-content">
              {header}
              <div className="modal-view-body" style={{ paddingBottom: "2em" }}>
                <p>{content}</p>
              </div>
              <div className="modal-view-footer">
                <a
                  className="modal-view-button-left-6"
                  onClick={() => handleRejectButton()}
                >
                  {rejectButtonName ? rejectButtonName : "キャンセル"}
                </a>
                <a
                  className="modal-view-button-right-6"
                  onClick={() => handleApproveButton()}
                >
                  {approveButtonName ? approveButtonName : "OK"}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default forwardRef(ModalConfirm);
